module.exports = __webpack_public_path__ + "media/audio3.5b6002be.mp3";